import { Directive, EventEmitter, OnInit, Output } from '@angular/core';
import { SecurityService } from '../../service';
import { RdaAutenticado } from '../model';

@Directive({
  selector: '[appResponsavelContratante]'
})
export class ResponsavelContratanteDirective implements OnInit {

  @Output() private readonly appResponsavelContratante: EventEmitter<RdaAutenticado> = new EventEmitter();

  constructor(private readonly securityService: SecurityService) {
  }

  ngOnInit(): void {
    this.securityService.obterRdaAutenticado().subscribe(rda => {
      if (!rda || rda.contratante) {
        this.appResponsavelContratante.emit(rda);
      }
    });
  }

}
